import React from "react";
import "./dataSearchList.scss";

const AddresSearchList = ({ data, setAddress, setShowList, setStreetRefValue }) => {
    const addItemHandler = (item) => {
        setAddress(item.Present);
        setShowList(false);
        setStreetRefValue(item.SettlementStreetRef);
    };

    return (
        <div className="dataSearchList">
            <ul className="list-group">
                {data.map((item) => {
                    return (
                        <li
                            className="list-group-item custom-list-item"
                            key={item.id}
                            onClick={() => addItemHandler(item)}
                        >
                            {item.Present}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default AddresSearchList;
